import type { SharedConfigOnly, SharedEnv } from './config.type';

/** default config (final format after computations)
 * may use defaultSharedEnv and SharedEnv to compute a SharedConfig
 * then this sharedConfig will be merged with this defaultSharedConfig
 */
export function defaultSharedConfigFactory(_environment: SharedEnv): SharedConfigOnly {
  return {};
}
